import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ChipItem } from '../../../../../components/internal/DurationPicker/components/Chips/components/ChiptItem.js';
import { Container } from '../../../../../components/internal/DurationPicker/components/Chips/components/Container.js';
export const Chips = ({
  items,
  maxDuration,
  selectedDays = 0,
  duration,
  isDeactivated,
  onClick
}) => {
  const handelDisable = itemDuration => {
    if (itemDuration === 0) {
      return selectedDays === 0 || selectedDays > maxDuration;
    }
    return itemDuration + 1 > maxDuration;
  };
  return _jsx(Container, {
    children: items.options.map((item, key) => _jsx(ChipItem, {
      item: item,
      isActive: !isDeactivated && item.min === duration.min && item.max === duration.max,
      disabled: handelDisable(item.max),
      onClick: onClick
    }, key))
  });
};